import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/rtlplusz_auth.png'


const _hoisted_1 = { style: {"display":"contents"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "auth" }
const _hoisted_4 = { class: "auth__left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "register-logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "rtlmost",
    class: "register-logo-wrap__logo"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Regisztráció e-mail címmel", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "Szuper hír! Az itt megadott adataiddal később az RTL+ oldalára és az RTL.hu mobilapplikációba is be tudsz majd lépni.*", -1)
const _hoisted_8 = {
  key: 0,
  ref: "errorBlock",
  class: "form-errors"
}
const _hoisted_9 = { class: "form-errors__error" }
const _hoisted_10 = { class: "auth__row auth__form-group" }
const _hoisted_11 = { class: "auth__col" }
const _hoisted_12 = { class: "auth__col" }
const _hoisted_13 = { class: "auth__form-group" }
const _hoisted_14 = { class: "auth__form-group" }
const _hoisted_15 = { class: "auth__row auth__form-group" }
const _hoisted_16 = { class: "auth__col" }
const _hoisted_17 = { class: "auth__col" }
const _hoisted_18 = { class: "auth__form-group" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Megismertem, és elfogadom az rtl.hu ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://rtl.hu/adatvedelmi-szabalyzat"
}, "adatkezelési tájékoztatóját", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" és az ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://rtl.hu/felhasznalasi-feltetelek"
}, "általános szerződési feltételeit", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_24 = { class: "auth__form-group" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "auth__bottom" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("*Már van RTL+ regisztrációd? Ide is be tudsz lépni a meglévő adataiddal, nem kell új fiókot létrehoznod. A belépési adataid erre a felületre is érvényesek. Válaszd a ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("belépés")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" opciót!")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "auth__middle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "auth__middle-text" }, "vagy")
], -1)
const _hoisted_31 = { class: "auth__right" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Regisztráció közösségi fiókkal", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "Válaszd ezt az opciót, ha rendelkezel valamelyikkel az alábbi fiókok közül!", -1)
const _hoisted_34 = {
  action: "",
  class: "auth__form"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Regisztráció Facebook fiókkal ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Regisztráció Google fiókkal ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Regisztráció apple fiókkal ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "auth__bottom" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Ezeket az adatokat csak egyetlen alkalommal, a regisztrációnál kérjük el az általad kiválasztott felületről. A létrejövő RTL fiókodban az adatokat később módosíthatod. (Ez a változtatás a közösségi oldalon lévő adataidat nem érinti.) Később az RTL nem fog a faladra posztolni.")
], -1)
const _hoisted_39 = { class: "auth__left" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Regisztráció e-mail címmel", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "Szuper hír! Az itt megadott adataiddal később az RTL+ oldalára és az RTL.hu mobilapplikációba is be tudsz majd lépni.*", -1)
const _hoisted_42 = {
  key: 0,
  ref: "errorBlock",
  class: "form-errors"
}
const _hoisted_43 = { class: "form-errors__error" }
const _hoisted_44 = { class: "auth__row auth__form-group" }
const _hoisted_45 = { class: "auth__col" }
const _hoisted_46 = { class: "auth__col" }
const _hoisted_47 = { class: "auth__form-group" }
const _hoisted_48 = { class: "auth__form-group" }
const _hoisted_49 = { class: "auth__row auth__form-group" }
const _hoisted_50 = { class: "auth__col" }
const _hoisted_51 = { class: "auth__col" }
const _hoisted_52 = { class: "auth__form-group" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Megismertem, és elfogadom az rtl.hu ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://rtl.hu/adatvedelmi-szabalyzat"
}, "adatkezelési tájékoztatóját", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" és az ")
const _hoisted_56 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://rtl.hu/felhasznalasi-feltetelek"
}, "általános szerződési feltételeit", -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_58 = { class: "auth__form-group" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "auth__bottom" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("*Már van RTL+ regisztrációd? Ide is be tudsz lépni a meglévő adataiddal, nem kell új fiókot létrehoznod. A belépési adataid erre a felületre is érvényesek. Válaszd a ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("belépés")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" opciót! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_social_link_account = _resolveComponent("social-link-account")!
  const _component_social_reg_finish = _resolveComponent("social-reg-finish")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FacebookFull = _resolveComponent("FacebookFull")!
  const _component_Google = _resolveComponent("Google")!
  const _component_Apple = _resolveComponent("Apple")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showLinkModal)
      ? (_openBlock(), _createBlock(_component_social_link_account, {
          key: 0,
          regToken: _ctx.regToken,
          loginID: _ctx.loginID,
          passwordUrl: _ctx.passwordUrl,
          successUrl: _ctx.successUrl
        }, null, 8, ["regToken", "loginID", "passwordUrl", "successUrl"]))
      : _createCommentVNode("", true),
    ((_ctx.showRegFinishModal && _ctx.user))
      ? (_openBlock(), _createBlock(_component_social_reg_finish, {
          key: 1,
          UID: _ctx.user.UID,
          successUrl: _ctx.successUrl
        }, null, 8, ["UID", "successUrl"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("form", {
              class: "auth__form",
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
            }, [
              (!_ctx.modalIsOpen && _ctx.hasFieldError('error'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.getFieldErrorValue('error')), 1)
                  ], 512))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_text_input, {
                    modelValue: _ctx.registerData.profile.lastName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerData.profile.lastName) = $event)),
                    label: "Vezetéknév",
                    placeholder: "Pl. Szabó",
                    "error-msg": _ctx.getFieldErrorValue('lastName')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_text_input, {
                    modelValue: _ctx.registerData.profile.firstName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerData.profile.firstName) = $event)),
                    label: "Keresztnév",
                    placeholder: "Pl. Dávid",
                    "error-msg": _ctx.getFieldErrorValue('firstName')
                  }, null, 8, ["modelValue", "error-msg"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_text_input, {
                  modelValue: _ctx.registerData.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerData.email) = $event)),
                  label: "E-mail cím",
                  "error-msg": _ctx.getFieldErrorValue('email')
                }, null, 8, ["modelValue", "error-msg"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_password_input, {
                  modelValue: _ctx.registerData.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerData.password) = $event)),
                  label: "Jelszó",
                  autocomplete: "new_password",
                  "error-msg": _ctx.getFieldErrorValue('password')
                }, null, 8, ["modelValue", "error-msg"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_date_input, {
                    modelValue: _ctx.birthDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.birthDate) = $event)),
                    className: 'auth__form-control',
                    label: "Születési idő",
                    "error-msg": _ctx.getFieldErrorValue('birthDate')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_Select, {
                    modelValue: _ctx.registerData.profile.gender,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerData.profile.gender) = $event)),
                    label: "Nem",
                    "error-msg": _ctx.getFieldErrorValue('gender'),
                    options: _ctx.genderOptions
                  }, null, 8, ["modelValue", "error-msg", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_checkbox, {
                  modelValue: _ctx.registerData.data.RTLHU_Consent,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerData.data.RTLHU_Consent) = $event)),
                  "error-msg": _ctx.getFieldErrorValue('RTLHU_Consent')
                }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]),
                  _: 1
                }, 8, ["modelValue", "error-msg"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_checkbox, {
                  label: "Szeretnék hírlevelet kapni, hozzájárulok az rtl.hu ilyen irányú megkeresésének a fent megadott e-mail címen (Opcionális)",
                  modelValue: _ctx.registerData.data.RTLHU_Newsletter,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerData.data.RTLHU_Newsletter) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "auth__button auth__button--primary",
                disabled: !_ctx.checkRequiredFields()
              }, " Regisztrálok ", 8, _hoisted_25),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", null, [
                  _hoisted_27,
                  _createVNode(_component_router_link, { to: _ctx.loginUrl }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_29
                ])
              ])
            ], 32)
          ]),
          (!_ctx.socialDisabled)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _hoisted_33,
                  _createElementVNode("form", _hoisted_34, [
                    _createElementVNode("button", {
                      class: "auth__button auth__button--facebook",
                      "data-social": "facebook",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.socialLogin && _ctx.socialLogin(...args))),
                      type: "button"
                    }, [
                      _createVNode(_component_FacebookFull),
                      _hoisted_35
                    ]),
                    _createElementVNode("button", {
                      "data-social": "google",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.socialLogin && _ctx.socialLogin(...args))),
                      class: "auth__button auth__button--google"
                    }, [
                      _createVNode(_component_Google),
                      _hoisted_36
                    ]),
                    _createElementVNode("button", {
                      "data-social": "apple",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.socialLogin && _ctx.socialLogin(...args))),
                      class: "auth__button auth__button--apple"
                    }, [
                      _createVNode(_component_Apple),
                      _hoisted_37
                    ]),
                    _hoisted_38
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.modalIsOpen)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.modalIsOpen = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _hoisted_41,
                _createElementVNode("form", {
                  class: "auth__form",
                  onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
                }, [
                  (_ctx.hasFieldError('error'))
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_42, [
                        _createElementVNode("li", _hoisted_43, _toDisplayString(_ctx.getFieldErrorValue('error')), 1)
                      ], 512))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_text_input, {
                        modelValue: _ctx.registerData.profile.lastName,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registerData.profile.lastName) = $event)),
                        label: "Vezetéknév",
                        placeholder: "Pl. Szabó",
                        "error-msg": _ctx.getFieldErrorValue('lastName')
                      }, null, 8, ["modelValue", "error-msg"])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_text_input, {
                        modelValue: _ctx.registerData.profile.firstName,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.registerData.profile.firstName) = $event)),
                        label: "Keresztnév",
                        placeholder: "Pl. Dávid",
                        "error-msg": _ctx.getFieldErrorValue('firstName')
                      }, null, 8, ["modelValue", "error-msg"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_text_input, {
                      modelValue: _ctx.registerData.email,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.registerData.email) = $event)),
                      label: "E-mail cím",
                      "error-msg": _ctx.getFieldErrorValue('email')
                    }, null, 8, ["modelValue", "error-msg"])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_password_input, {
                      modelValue: _ctx.registerData.password,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.registerData.password) = $event)),
                      label: "Jelszó",
                      autocomplete: "new_password",
                      "error-msg": _ctx.getFieldErrorValue('password')
                    }, null, 8, ["modelValue", "error-msg"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_date_input, {
                        modelValue: _ctx.birthDate,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.birthDate) = $event)),
                        label: "Születési idő",
                        className: 'auth__form-control',
                        "error-msg": _ctx.getFieldErrorValue('birthDate')
                      }, null, 8, ["modelValue", "error-msg"])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_Select, {
                        modelValue: _ctx.registerData.profile.gender,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.registerData.profile.gender) = $event)),
                        label: "Nem",
                        "error-msg": _ctx.getFieldErrorValue('gender'),
                        options: _ctx.genderOptions
                      }, null, 8, ["modelValue", "error-msg", "options"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_checkbox, {
                      modelValue: _ctx.registerData.data.RTLHU_Consent,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.registerData.data.RTLHU_Consent) = $event)),
                      "error-msg": _ctx.getFieldErrorValue('RTLHU_Consent')
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53,
                        _hoisted_54,
                        _hoisted_55,
                        _hoisted_56,
                        _hoisted_57
                      ]),
                      _: 1
                    }, 8, ["modelValue", "error-msg"])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_checkbox, {
                      label: "Szeretnék hírlevelet kapni, hozzájárulok az rtl.hu ilyen irányú megkeresésének a fent megadott e-mail címen (Opcionális)",
                      modelValue: _ctx.registerData.data.RTLHU_Newsletter,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.registerData.data.RTLHU_Newsletter) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "auth__button auth__button--primary",
                    disabled: !_ctx.checkRequiredFields()
                  }, " Regisztrálok ", 8, _hoisted_59),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("p", null, [
                      _hoisted_61,
                      _createVNode(_component_router_link, { to: _ctx.loginUrl }, {
                        default: _withCtx(() => [
                          _hoisted_62
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_63
                    ])
                  ])
                ], 32)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}